import React from "react";
import Button from "../../components/ui/Button";

const ResearchSection = () => {
  return (
    <section className="w-full bg-white mt-[50px]">
      <div className="max-w-[1800px] mx-auto flex flex-col md:flex-row items-center gap-12">
        {/* Left Content Column */}
        <div className="w-full md:w-1/2 flex flex-col space-y-6  pr-6 md:pr-0 pl-6 py-12 md:py-20">
          <h1 className="text-[24px] md:text-[30px] lg:text-[40px] 2xl:text-[60px] font-extrabold text-[#183076] leading-tight">
            Advanced Analytical <br />
            Capabilities for Global <br />
            Research
          </h1>

          <p className=" text-[18px] xl:text-[24px]  leading-relaxed text-justify">
            Beyond specimen supply, we offer specialized testing services to
            support your research objectives. From basic characterization to
            complex validation studies, our central laboratory brings technical
            expertise and validated methodologies to accelerate your projects.
          </p>

          <div className="flex flex-wrap gap-4 pt-4">
            {/* <Button
              className="border-2 border-[#183076] text-[#183076] px-8 py-3 rounded-full font-bold hover:bg-[#183076] hover:text-white transition text-[16px] md:text-[18px] 2xl:text-[24px]"
              text="Discuss Testing Services"
              to="/contact"
            /> */}
            <Button
              className="border-2 border-[#183076] text-[#183076] px-8 py-3 rounded-full font-bold hover:bg-[#183076] hover:text-white transition text-[16px] md:text-[18px] 2xl:text-[24px]"
              text="Book Now"
              to="/rfq"
            />
          </div>
        </div>

        {/* Right Image/Graphic Column */}
        <div className="w-full md:w-1/2">
          <div className="relative w-full aspect-square md:aspect-auto md:h-[100%] rounded-3xl overflow-hidden shadow-sm">
            {/* Replace the src with your actual image path */}
            <img
              src="/images/LabTesting/lab-testing-hero.png"
              alt="Microscopic bubbles or cells abstract"
              className="w-full h-full object-cover"
            />
            {/* Optional Overlay for a soft look */}
            <div className="absolute inset-0 bg-blue-50/10 mix-blend-multiply pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResearchSection;
